
const window = require('window');
let $ = require('jquery');


// XDomainRequest turns out not to be needed (for ie9) with help of the hack below
// require('jquery-ajax-transport-xdomainrequest/jQuery.XDomainRequest.js');
if (/msie 9\.0/i.test((window.navigator || {}).userAgent)) {
	$.support.cors = true;
}

if ($.noConflict) { // browser
	$.noConflict(true);
} else { // node
	$ = $(window);
}

module.exports = $;

